module.exports = __webpack_public_path__ + "school/img/practice.43c4e4d3.jpg";